<template>
    <div>      
      <Head>
        <title>Backtoworkconnect.ie {{event.title}}</title>
        <link rel="canonical" :href="'https://backtoworkconnect.ie/event/'+event.alias" />
        <meta head-key="description" name="description" :content="metaDescription" />
      </Head>

      <v-container class="lighten-5" style="padding-bottom:65px">
        
        <v-card outlined elevation="24">
           
            <v-card-title>
                <span class="text-lg-h3 text-md-h4">{{event.title}}</span>
                
            </v-card-title>
            <v-card-subtitle class="mt-5" v-if="msg">
                <v-alert :type="alert_type">{{ msg }}</v-alert>
            </v-card-subtitle>
            <v-card-text style="min-height:500px">
                <v-card outlined elevation="24" shaped class="hidden-lg-and-up border-bottom-purple mb-10">
                    <v-card-text class="text-center">
                        <v-img :src="baseurl + '/img/' + event.photo_path"></v-img>
                        
                        
                    </v-card-text>
                </v-card>
                <v-container class="border-bottom-purple">
                    <v-row>
                        <v-col  cols="12" lg="8" sm="12">
                            <v-container>
                                
                                <v-row>
                                    <v-col cols="12" md="10" sm="12" class="bottom-border-purple">
                                        <span class="text-h5">Details</span>
                                    </v-col>
                                </v-row>
                                <v-row v-if="event.description">
                                    <v-col cols="12"  md="12">
                                        <span class="text-lg-h6">Description</span>
                                        <div class="rich-text" v-html="event.description"></div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="10" sm="12" class="bottom-border-purple">
                                        <span class="text-h5">Event Details</span>
                                    </v-col>
                                    <v-col cols="12" lg="6" md="12" v-if="event.start_date">
                                        <span class="text-lg-h6"><v-icon left>mdi-calendar</v-icon>Date</span>
                                        <p><span>{{ prettyDate(event.start_date) }}</span><span v-if="event.end_date && event.end_date != event.start_date"> - {{ prettyDate(event.end_date) }}</span></p>
                                    </v-col>
                                    <v-col cols="12" lg="6" md="12" v-if="event.start_time">
                                        <span class="text-lg-h6"><v-icon left>mdi-clock</v-icon>Time</span>
                                        <p><span>{{ prettyTime(event.start_time) }}</span><span v-if="event.end_time"> - {{ prettyTime(event.end_time) }}</span></p>
                                    </v-col>
                                    
                                    <v-col cols="12" lg="6" md="12" v-if="event.location=='In-person'">
                                        <span class="text-lg-h6"><a :href="getUrl()" target="_blank"><v-icon left>mdi-map</v-icon></a>Location</span>
                                        <p><span v-if="event.address">{{ event.address }}</span>&nbsp;<span v-if="event.city">{{ event.city }}</span>&nbsp;<span v-if="event.postal_code">{{ event.postal_code }}</span>&nbsp;{{event.region}}&nbsp;<a :href="getUrl()" target="_blank"><v-icon>mdi-open-in-new</v-icon></a></p>
                                    </v-col>
                                    <v-col cols="12" lg="6" md="12" v-if="event.location=='Online'">
                                        <span class="text-lg-h6">{{event.event_link_description}}</span>
                                        <p>A link to the event will be emailed to you.</p>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                        <v-col cols=12 lg="4" sm="12">
                            <v-dialog v-model="showUnregisteredBookingModal" max-width="500px">
                                <v-card>
                                <v-card-title>Book Event Ticket</v-card-title>
                                <v-card-text>
                                    <v-form @submit.prevent="submitUnregisteredBooking">
                                    <v-text-field
                                        v-model="unregisteredBooking.email"
                                        label="Email"
                                        required
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="unregisteredBooking.name"
                                        label="Name"
                                        required
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="unregisteredBooking.organization"
                                        label="Organization"
                                    ></v-text-field>
                                    <v-select
                                        v-model="unregisteredBooking.referral"
                                        :items="referralOptions"
                                        label="How did you hear about us?"
                                        required
                                    ></v-select>
                                    <v-btn type="submit" color="primary" :loading="booking">
                                        Book Ticket
                                    </v-btn>
                                    </v-form>
                                </v-card-text>
                                </v-card>
                            </v-dialog>
                            <v-card outlined elevation="24" shaped class="mt-10" v-if="!event.require_registration && !auth.user && eventNotStarted(event.start_date) && event.status">
                                <v-card-title class="bottom-border-purple dark-grey--text text-h5 mb-5">Reserve a ticket</v-card-title> 
                                
                                <v-card-text class="text-center p-10" v-if="free_spaces">
                                    <p v-if="free_spaces > 1">There are only {{ free_spaces }} spaces left.</p>
                                    <p v-if="free_spaces == 1">There is only {{ free_spaces }} space left.</p>
                                    
                                    <v-btn primary @click="bookTicketUnregistered" :disabled="booking"><v-icon v-if="!booking">mdi-ticket</v-icon><v-progress-circular v-if="booking" indeterminate color="primary"></v-progress-circular> Book now</v-btn>
                                </v-card-text>
                                <v-card-text v-else>
                                    <p>This event is sold out.</p>
                                </v-card-text>
                            </v-card>
                            <v-card outlined elevation="24" shaped class="mt-10" v-if="(event.require_registration || auth.user) && eventNotStarted(event.start_date) && event.status">
                                <v-card-title class="bottom-border-purple dark-grey--text text-h5 mb-5">Reserve a ticket</v-card-title> 
                                <v-card-text class="text-center p-10" v-if="!auth.user">
                                    <p v-if="free_spaces > 1">There are {{ free_spaces }} spaces left.</p>
                                    <p v-if="free_spaces == 1">There is {{ free_spaces }} space left.</p>
                                    <v-btn @click="toggleComponentLogin('eventview-'+event.id)" primary>Register or Login</v-btn>
                                </v-card-text>
                                <v-card-text class="text-center p-10" v-else-if="0 && !auth.user.email_verified_at">
                                    <p v-if="free_spaces > 1">There are {{ free_spaces }} spaces left.</p>
                                    <p v-if="free_spaces == 1">There is {{ free_spaces }} space left.</p>
                                    <p>Please verify your email to book.</p>
                                </v-card-text>
                                <v-card-text class="text-center p-10" v-else-if="free_spaces && !isBooked && event.require_cv && !hasResume">
                                    <p>This event requires a resume.</p>
                                    <v-btn @click="showResumeModal = true" color="primary">Upload one now</v-btn>
                                </v-card-text>
                                <v-card-text class="text-center p-10" v-else-if="free_spaces && !isBooked">
                                    <p v-if="free_spaces > 1">There are only {{ free_spaces }} spaces left.</p>
                                    <p v-if="free_spaces == 1">There is only {{ free_spaces }} space left.</p>
                                    
                                    <v-btn primary @click="bookTicket" :disabled="booking"><v-icon v-if="!booking">mdi-ticket</v-icon><v-progress-circular v-if="booking" indeterminate color="primary"></v-progress-circular> Book now</v-btn>
                                </v-card-text>
                                <v-card-text class="text-center" v-else-if="free_spaces && isBooked">
                                    <p>You are signed up for this event.</p>
                                    <v-btn @click="cancelTicket" primary :disabled="canceling"><v-icon v-if="!canceling">mdi-ticket</v-icon><v-progress-circular v-if="canceling" indeterminate color="primary"></v-progress-circular> Cancel Booking</v-btn>
                                </v-card-text>
                                <v-card-text v-else>
                                    <p>This event is sold out.</p>
                                </v-card-text>
                            </v-card>
                            <v-card outlined elevation="24" shaped class="mt-10" v-if="!eventNotStarted(event.start_date) || !event.status">
                                <v-card-title class="bottom-border-purple dark-grey--text text-h5 mb-5">Event Information</v-card-title> 
                                
                                <v-card-text>
                                    <p>Booking for this event has closed. Stay tuned for more events.</p>
                                </v-card-text>
                            </v-card>
                            <v-img style="margin-top:15px" :src="baseurl + '/img/' + event.photo_path" max-height="250" contain class="hidden-md-and-down "></v-img>
                        </v-col>
                    </v-row>
                </v-container>
                
                
            </v-card-text>
            
        </v-card>
      </v-container>

      <v-dialog v-model="showResumeModal" max-width="800" @update:model-value="onResumeModalChange">
        <v-card>
            <v-card-title>
                Upload Resume
                <v-spacer></v-spacer>
                <v-btn icon @click="showResumeModal = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <UserFiles :baseurl="baseurl"/>
            </v-card-text>
        </v-card>
    </v-dialog>
    </div>
</template>
<script>
  import { router, Head,Link } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import axios from 'axios'
import UserFiles from '@/Shared/UserFiles'

  export default {
    props: {
      auth: Object,
      state: String,
      isBooked: Boolean,
      baseurl: String,
      prevurl: String,
      event: Object,
      free_spaces: Number,
      msg: String,
      alert_type: String,
      hasResume: Boolean,
      metaDescription: String
    },
    components: {
      Head,
      Link,
      UserFiles
    },
    layout: Layout,
    data() {
        return {
            booking:false,
            canceling:false,
            showResumeModal:false,

            showUnregisteredBookingModal: false,
            unregisteredBooking: {
                email: '',
                name: '',
                organization: '',
                referral: '',
            },
            referralOptions: [
                'Newsletter',
                'Instagram',
                'Facebook',
                'Google',
                'Other',
            ],
        }
    },
    watch: {
        showResumeModal: function(newVal,oldVal) {
            if (!newVal  && oldVal)
            {
                this.$inertia.reload({ preserveState: false, preserveScroll: false });
        
            }
        }
    },
    created() {
    },
    methods: {
        bookTicketUnregistered() {
        this.showUnregisteredBookingModal = true;
        },
        submitUnregisteredBooking() {
            this.booking = true;
            this.$inertia.post('', {
                action: 'book_unregistered',
                email: this.unregisteredBooking.email,
                name: this.unregisteredBooking.name,
                organization: this.unregisteredBooking.organization,
                referral: this.unregisteredBooking.referral,
            }, {
                preserveState: false,
                preserveScroll: true,
                onSuccess: () => {
                    this.booking = false;
                    this.showUnregisteredBookingModal = false;
                },
                onError: () => {
                    this.booking = false;
                },
            });
        },
        onResumeModalChange() {
            console.log('modal changed')
            if (!this.showResumeModal) {
                console.log('reload')
                this.$inertia.reload({ preserveState: false, preserveScroll: false });
                this.showResumeModal = false;
            }
        },
        toggleComponentLogin(e) {
           // console.log('results triggering login',e)
            if (!this.auth.user)
                this.$parent.$emit('toggleComponentLogin',e);
        
        },
        canApply() {
            //console.log('in can apply',this.auth.user)
            if (!this.auth.user || (this.auth.user.roles.includes('admin') || this.auth.user.roles.includes('user')))
                return true;
            else
                return false;
        },
        getUrl() {
            return 'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(this.event.address +','+this.event.region)

        },
        eventNotStarted(x) {
            //console.log('comparing ',x,new Date(x),new Date(),new Date(x) < new Date())
            return new Date(x) > new Date();
        },
        prettyDate(x) {
            var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

            return new Date(x).toLocaleDateString(undefined,options)
        },
        prettyTime(x) {
            return x.slice(0, -3).replace(/^[0]/g,"");
        },
        bookTicket() {
            this.booking = true;
            var vm = this;
            this.$inertia.post('', {action: 'book'}, {
                onSuccess: () => vm.booking=false,
                onError: () => vm.booking=false,
            });
            
/*
            const formData = new FormData();
            formData.append(0, this.event.id)
            axios.post("book",formData).then((response) => {
            if (response.status == '200' && response.data == true)
            {
                this.msg = response.data;
                this.booking = false;
                location.reload();
                
            }
            else
                this.msg = response;
            
                console.log('booking response',response)
                this.booking = false;
            });*/
        },
        cancelTicket() {
            this.canceling = true;
            this.$inertia.post('', {action: 'cancel'});
/*
            const formData = new FormData();
            formData.append(0, this.event.id)
            axios.post("cancel",formData).then((response) => {
            if (response.status == '200' && response.data == true)
            {
                this.msg = response.data;
                this.canceling = false;
                location.reload();
            }
            else
                this.msg = response;
            
                console.log('canceling response',response)
                this.canceling = false;
            });*/
        }
    },
  }
  </script>
  
  <style>
    .fixedFooter {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    }
    </style>